import { render, staticRenderFns } from "./ZyroNotification.vue?vue&type=template&id=0fd81a8e&scoped=true&"
import script from "./ZyroNotification.vue?vue&type=script&lang=js&"
export * from "./ZyroNotification.vue?vue&type=script&lang=js&"
import style0 from "./ZyroNotification.vue?vue&type=style&index=0&id=0fd81a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd81a8e",
  null
  
)

export default component.exports